import { createSelector } from "@ngxs/store";
import { AuthState } from "./auth.state";
import { Token } from "./auth.model";

export const getTokens = () =>
  createSelector([AuthState], (state: Token) => state);